import Vue from 'vue'
import Vuex from 'vuex'
import {firebase} from '../firebase/firebase'
import moment from 'moment'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    liffUserData:{},
    allCompetesDatas:{},
    competesDatas:{},
    userData:{},
    userScore:{},
    courseScore:{},
    myGameDatas:{},
    myGameCourseScore:{},
    fetchDataState:false,
    fetchAllCompetesDatas:false,
    fetchUserScore:false,
    fetchMyGame:false,
    fetchMyGameScore:false,
    appTabFooterActive:"home",
    // liffUserId : "U82f5b8141e400e67d708651cefd4f0b1",
    userAllMailMessage:"",
    mailMessage:[],
    groupList:false,
  },
  getters:{
    competesUserSortable:(state)=>{  //拿到competeOrder資料後 先排序 在依照組別的array做整理
      let competeOrder = state.competesDatas.competeOrder
      let orderKey = Object.keys(competeOrder).sort((a,b)=>{
        return competeOrder[a]['group']-competeOrder[b]['group']
      })

      let newCompeteOrder = {grouping:{}}
      for(let i of orderKey){
          if(!newCompeteOrder['grouping'][competeOrder[i]['group']] && competeOrder[i]['group']!=0){ //newCompeteOrder[group] 如果不存在 宣告一個 
              newCompeteOrder['grouping'][competeOrder[i]['group']] = []
          }
          else if(!newCompeteOrder['waitingList'] && competeOrder[i]['group']==0) {
            newCompeteOrder['waitingList'] = []
          }
          
          if(competeOrder[i]['group']!=0){
            newCompeteOrder['grouping'][competeOrder[i]['group']].push({id:i,group:competeOrder[i]['group'],time:competeOrder[i]['time']})
          }
          else{
            newCompeteOrder['waitingList'].push({id:i,group:competeOrder[i]['group'],time:competeOrder[i]['time']})
          }
          //newCompeteOrder[group].push userData
      }
      if(competeOrder[state.liffUserData.userId]){
        newCompeteOrder['mainGroup'] = competeOrder[state.liffUserData.userId]['group']
      }
      return  newCompeteOrder
    },
    courseScore:(state) => {
      let orderScore = [
        [{fields: ['title'], title: 'HDCP', titleAlign: 'center'}],
        [{fields: ['title'], title: 'BLUE', titleAlign: 'center'}],
        [{fields: ['title'], title: 'WHITE', titleAlign: 'center'}],
        [{fields: ['title'], title: 'RED', titleAlign: 'center'}],
        [{fields: ['title'], title: 'PAR', titleAlign: 'center'}]
      ]
      const scoreSetting = 
      ['1','2','3','4','5','6','7','8','9','OUT','10','11','12','13','14','15','16','17','18','IN','TOT','HDCP','NET']
      const scoreTitle = 
      ['難易度','Blue','White','Red','標準桿']
      const scoreSelectAreaScore = {}
      for(let i in state.competesDatas.area){
        //state [球場計分資料] [打了哪幾個球道[ 有兩個 =>i ]] 會拿到 a區{ 難易度:{1:1...} }
        
        const courseScoreTem = state['courseScore'][state.competesDatas.area[i]]

        // console.log("i",state.competesDatas.area[i])
        // console.log(state['courseScore'])
        // console.log(courseScoreTem)

        //a區{ 難易度:{1:1...} } =>把難易度...的資料抽出
        for(let j of scoreTitle){
            // console.log(scoreSelectAreaScore)
           //裡面是{1:1,2:3.......} => 把數字合併起來 {1:1,... 18:13}
           if(!scoreSelectAreaScore[j]){scoreSelectAreaScore[j] = {}}
           Object.assign(scoreSelectAreaScore[j],courseScoreTem[j])
        }
      }

      for(let i in scoreTitle){
          // 整理 par 資料
         for(let j in scoreSelectAreaScore[ scoreTitle[i]]){
          j
          // console.log(j)
          let start = 0
          let sum = 0 
          let par = ['IN','OUT']
          for(let k=1;k<=18;k++){
            while(!scoreSelectAreaScore[ scoreTitle[i]][ k+start ]){ //1-18 10-27 19-36 不一定 起始值每次+9
              start = start + 9
            }
             //把數字整成 1,2,3.... 符合打印的樣式 不然 19-36抓不到
            scoreSelectAreaScore[ scoreTitle[i]][ k ] = scoreSelectAreaScore[ scoreTitle[i]][ k+start ]
            sum = sum + scoreSelectAreaScore[ scoreTitle[i]][ k ]
            //整理in與out 但是 難易度 不用
            if(k%9 == 0 && scoreTitle[i]!="難易度"){
              let key = par.pop()
              scoreSelectAreaScore[ scoreTitle[i]][key] = sum
              sum = 0 
            }
          }
         }
         
         //會跑scoreSetting的回圈 如果裡面沒有值就會是 "-" 號
        for(let j of scoreSetting){
          let titleVal = scoreSelectAreaScore[ scoreTitle[i] ][j] ? scoreSelectAreaScore[ scoreTitle[i] ][j] : "-"
          // if( scoreTitle[i]=='難易度' &&(j=='OUT' || j =='IN') ){continue}
          orderScore[i].push({'fields': [j], 'title': titleVal, 'titleAlign': 'center'})
        }
      }
      return orderScore
    },
    courseScoreOrgin:(state)=>{
      return state.courseScore
    },
    userScore:state => {
      // console.log(state.userScore)
      return state.userScore
    },
    allCompetesDatas:state => state.allCompetesDatas,
    fetchAllCompetesDatas:state => state.fetchAllCompetesDatas,
    competesDatas:state => state.competesDatas,
    userData:state => state.userData,
    fetchDataState:state => state.fetchDataState,
    liffUserData:state => state.liffUserData,
    fetchUserScore:state => state.fetchUserScore,
    fetchMyGame:state => state.fetchMyGame,
    myGameDatas:state => state.myGameDatas,
    myGameCourseScore:state => state.myGameCourseScore,
    fetchMyGameScore:state => state.fetchMyGameScore,
    appTabFooterActive:state => state.appTabFooterActive,
    userAllMailMessage:state => state.userAllMailMessage,
    mailMessage:state => state.mailMessage,
    groupList:state => state.groupList,
  },
  mutations: {
      setFetchUserScore:(state,data)=>{
        state.fetchUserScore = data
      },
      setUserScore:(state,{data,userId})=>{
        Vue.set(state.userScore,userId,data)
      },
      resetUserScore:(state)=>{
        state.userScore = {}
      },
      setFetchAllCompetesDatas:(state,data)=>{
        state.fetchAllCompetesDatas = data
      },
      setAllCompetesDatas:(state,data)=>{
        state.allCompetesDatas = data
      },
      setCompetesData: (state,data) => {
        state.competesDatas = data
      },
      setUserData:(state,data) =>{
        state.userData = data
      },
      setLiffUserData:(state,data) => {
        state.liffUserData = data
      },
      fetchDataState:(state,data) =>{
        state.fetchDataState = data
      },
      setCourseScore:(state,data)=>{
        // console.log(data)
        state.courseScore = data
      },
      setFetchMyGame:(state,data)=>{
        state.fetchMyGame = data
      },
      setMyGameDatas:(state,data)=>{
        state.myGameDatas = data
      },
      setMyGameCourseScore:(state,data)=>{
        state.myGameCourseScore = data
      },
      setFetchMyGameScore:(state,data)=>{
        state.fetchMyGameScore = data
      },
      setAppTabFooterActive:(state,data)=>{
        state.appTabFooterActive = data
      },
      setUserAllMailMessage:(state,data)=>{
        state.userAllMailMessage = data
      },
      setMailMessage:(state,data)=>{
        state.mailMessage.push(data)
      },
      setGroupList:(state,data)=>{
        state.groupList = data
      }
  },
  actions: {
    async initLiffUserData({commit,dispatch}){
        const liff = window.liff
        let Os
        // return liff.init({liffId: "1650128613-LqXzd8J7" }).then(async()=>{
        // if(!liff.isInClient()){
        //   alert("請使用line的介面開啟Golfourit的App哦!")
        //   liff.closeWindow();
        // }
        const {type,groupId,roomId,availability} =  liff.getContext();
        Os = liff.getOS()
        const {userId,displayName,pictureUrl} = await liff.getProfile()
        
        // const {friendFlag} = await liff.getFriendship()friendFlag,
        const Language = liff.getLanguage()
        const LineVersion = liff.getLineVersion()
        firebase.database().ref(`users/${userId}/name`).set(displayName)
        firebase.database().ref(`users/${userId}/profileImageUrl`).set(pictureUrl)
        firebase.database().ref(`users/${userId}/user_id`).set(userId)
        const firebasePromise1 = firebase.database().ref(`users/${userId}`).once("value")
        const firebasePromise2 =  dispatch("initUserAllMailMessage",userId)
  
        return Promise.all([firebasePromise1,firebasePromise2]).then((data)=>{
          // console.log("hiInitPromise")
          const {phoneNumber,hometown,gender,realName,corp} =  data[0].val()
          commit("setLiffUserData",{
            type,groupId,roomId,availability,
            Os,Language,LineVersion,userId,displayName,pictureUrl,
            phoneNumber,hometown,gender,realName,corp
          })
        })
        
        // .catch((err)=>{
        //   console.log("我是錯誤")
        //   console.log(err)

        //   if(Os.includes("ios")){liff.login()}
          
        //   commit("setLiffUserData",{
        //     userId:"U1e7df7dcfafdfffd208806c1187a5417",
        //     pictureUrl:"https://profile.line-scdn.net/0hynwh2knsJkFKEQ2Zs9BZFnZUKCw9PyAJMnNgc2kXenNgImZFJXJtJWgYeyE3dWEednNoJjgRfHM1",
        //     displayName:"吳俊毅"
        //   })
        //   dispatch("initUserAllMailMessage")
          
        // })


        // liff.ready.then(()=>{
        //   console.log("hi ready")
        // })
        // const {userId,displayName,pictureUrl,statusMessage} = await liff.getProfile()
        // liff.addToHomeScreen()
        // liff.userPicker([{type:"text",text:"1234"}])
    },
    initAllCompetesData({commit}){
      return new Promise((resolve) => {
        //moment(new Date().setDate(new Date().getDate()-1)
        firebase.database()
        .ref("competes")
        .orderByChild("open_date")
        .startAt(moment(new Date()).format('YYYY-MM-DD'))
        .on("value",async (snapshot)=>{
          let data = snapshot.val()
          for(let i in data){
            if(data[i]['private_game'] == false){
              let {profileImageUrl,displayName,hometown,gender,realName} = await(await firebase.database().ref("users/"+data[i]['userId']).once("value")).val()
              data[i]['profileImageUrl'] = profileImageUrl
              data[i]['name'] = realName ? realName : displayName
              data[i]['hometown'] = hometown ? hometown : "未填寫"
              data[i]['gender'] = gender=="Male" ? "男" : "女"
            }
          }
          commit("setAllCompetesDatas",data)
          commit("setFetchAllCompetesDatas",true)
          resolve()
        })
      }).catch((err)=>{
        console.log(err)
      })
    },

    initCompetesData({commit,dispatch},CompetesKey){
      return new Promise((resolve) => {
        firebase.database().ref("competes/"+CompetesKey).on("value",async (snapshot)=>{
          commit("setCompetesData",snapshot.val())
          let {competeOrder , donateOrder , restaurantOrder} = snapshot.val()
          let allUserData = {}
          if(donateOrder){Object.assign(allUserData,donateOrder)}
          if(restaurantOrder){Object.assign(allUserData,restaurantOrder)}
          if(competeOrder){Object.assign(allUserData,competeOrder)}
          
          if(Object.keys(allUserData).length != 0)
          {
            await dispatch('initUserData',allUserData)
          }
          resolve()
        })
      })
    },
    async initUserData({commit},competeOrder){
      let promise = []
      for(let i in competeOrder){
        let userData = firebase.database().ref(`users/${i}`).once('value')
        promise.push(userData)
      }
      return Promise.all(promise).then((userSolveData)=>{
        let data = {}
        userSolveData.forEach((snap)=>{
          data[snap.key] = snap.val()
        })
        commit("setUserData",data)
        commit("fetchDataState",true)
      })
      
    },

    async userScore({commit,state,dispatch},CompetesKey){
      // if(!state.competesDatas){
        await dispatch("initCompetesData",CompetesKey) // 會先檢查有無球場資料 沒有的話init 球場資料
      // }
      await dispatch("courseScore") //載入球場標準計分卡 
      const data = []
      for(let i in state.userData){ //載入使用者分數 
        data.push(new Promise((resolve) => {
          firebase.database().ref("/user-scores/" + i + "/" + CompetesKey).on("value",(sanp)=>{
           
            let data = sanp.val()
            if(!sanp.val()){data = {'score':false}}
            data['userId'] = i
            data['title'] = state.userData[i]
            commit("setUserScore",{data,"userId":i})
            resolve()
          })
        }))
      }
      Promise.all(data).then(()=> commit("setFetchUserScore",true))
    },
    async courseScore({commit,state}){ //已經有球場名稱資料 直接重state找
      const data = await firebase.database().ref(`courses/${state.competesDatas.course_name}/score_card`).once("value")
      commit("setCourseScore",data.val())
    },
    async initMyGame({commit,state}){
      let gameArr = []
      
      await firebase.database().ref(`user-games/${state.liffUserData.userId}`).once('value',(gameKey)=>{
        gameKey.forEach((data)=>{
          gameArr.push(firebase.database().ref(`competes/${data.key}`).once('value'))
        })
      }).then(()=>{
        Promise.all(gameArr).then((dataArr)=>{
          let games = {}
          try{
            for(let i of dataArr){
              if(!i.val()){continue}
              let {course_name,competeOrder,game_name,open_date,img,area} = i.val()
              if(!games[course_name]){ 
                games[course_name] = {} 
                games[course_name]['key'] = []
                games[course_name]['img'] = img
              }
              let sameGroupUser = []
              for(let j in competeOrder){
                if(!competeOrder[state.liffUserData.userId]['group'])continue
                if(competeOrder[j]['group'] == competeOrder[state.liffUserData.userId]['group']){
                  competeOrder[j]['id'] = j
                  sameGroupUser.push({userData:competeOrder[j]})
                }
              }
              let data = {
                key:i.key,
                userLength:Object.keys(competeOrder).length,
                game_name,
                open_date,
                sameGroupUser,
                area,
              }
            
              games[course_name]['key'].push(data)
            }
          }
          catch(err){
            console.log(err)
          }
          commit("setFetchMyGame",true)
          commit("setMyGameDatas",games)
        })
      })
      
    },
    async ininMyGameCourseScore({state,commit,dispatch},courseName){
      if(!state.fetchMyGame){
        await dispatch("initMyGame")
      }
      const data = await firebase.database().ref(`courses/${courseName}/score_card`).once("value")
      let promiseArray = []

      for(let i of state.myGameDatas[courseName]['key']){
        for(let j of i['sameGroupUser'])
        {
          let userData = firebase.database().ref(`users/${j['userData']['id']}`).once('value',(snap)=>{
            let {name,realName,profileImageUrl} = snap.val()
            j['userData'].name = realName ? realName : name
            j['userData'].profileImageUrl = profileImageUrl
            // console.log(i)
          })
          promiseArray.push(userData)
          let userScore = firebase.database().ref(`/user-scores/${j['userData']['id']}/${i.key}`).once("value",(snap)=>{
            j['userData']['score'] = []
            
            if(snap.val()){
              let sum = 0
              let tot = 0 
              let field = ["1","2","3","4","5","6","7","8","9","OUT","10","11","12","13","14","15","16","17","18","IN","TOT","HDCP","NET"]
              for(let k of field){
                if(k=="OUT"){
                  if(!isNaN(sum)) {
                    j['userData']['score'].push(sum)
                    tot += sum
                  }
                  else{j['userData']['score'].push('-')}
                  sum = 0
                }
                else if(k=="IN"){
                  if(!isNaN(sum)) {
                    tot += sum
                    j['userData']['score'].push(sum)
                  }
                  else{j['userData']['score'].push('-')}
                  sum = 0
                }
                else if(k=="TOT"){
                  if(!isNaN(tot)){
                    if(j['userData']['id'] == state.liffUserData.userId){i['TOT'] = tot}
                    j['userData']['score'].push(tot)
                  }
                  else{
                    j['userData']['score'].push('-')
                  }
                }
                else if(k=="HDCP" && snap.val()[k]){
                  if(!isNaN(tot)){j['userData']['score'].push(tot - snap.val()[k])}
                  else{j['userData']['score'].push('-')}
                }
                else if(snap.val()[k]){
                  sum += parseInt(snap.val()[k])
                  j['userData']['score'].push(snap.val()[k])
                }
                else {
                  sum += '-'
                  j['userData']['score'].push('-')
                }
              }
            }
            else{
              j['userData']['score'] = new Array(23)
              j['userData']['score'].fill("-", 0, 23)
            }
          })
          promiseArray.push(userScore)
        }
      }
      await Promise.all(promiseArray).then(()=>{
          commit("setMyGameCourseScore",data.val())
          commit("setFetchMyGameScore",true)
        })
      
    },
    initUserAllMailMessage({commit},userId){
      console.log("hiInit")
      return new Promise((resolve)=>{
        firebase.database().ref(`userMailMessage/${userId}`).on('value',(snapshot)=>{
          commit('setUserAllMailMessage',snapshot.val())
          resolve(snapshot.val())
        })
      })
    },
    initMailMessage({state,commit},userId){
      const roomId = state.liffUserData.userId < userId ? 
      state.liffUserData.userId + '_' + userId :
      userId + '_' + state.liffUserData.userId
      firebase.database().ref(`mail_message/${roomId}`).on('child_added',(snapshot)=>{
        commit('setMailMessage',snapshot.val())
      })
    },
    async initGroupList({state,commit}){
      const data = await firebase.database().ref(`users-group/${state.liffUserData.userId}`).once('value')
      commit('setGroupList',data.val())
    }
  },
  modules: {
  }
})
